import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-data',
	templateUrl: './icon-data.component.svg',
})
export class IconDataComponent {}
